import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-cards.css';
import { UitkCardPlaceholderStartPhases, UitkCardPlaceholderAspectRatios } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkCardPlaceholder = function (props) {
    var aspectRatio = props.aspectRatio, children = props.children, className = props.className, startPhase = props.startPhase, attributes = __rest(props, ["aspectRatio", "children", "className", "startPhase"]);
    var secondaryButton;
    // Map through the children and place the ones we want in specific places
    React.Children.forEach(children, function (child) {
        if (!child) {
            return;
        }
        switch (child.type.displayName) {
            case 'UitkSecondaryButton':
                secondaryButton = child;
                break;
        }
    });
    var baseClass = 'uitk-card-placeholder';
    var ratioClass = aspectRatio
        ? UitkCardPlaceholderAspectRatios.get(aspectRatio)
        : UitkCardPlaceholderAspectRatios.get('r1-3');
    var cssClassNames = getClassNameList(baseClass, !secondaryButton && "".concat(baseClass, "-animate-from-").concat(startPhase), secondaryButton && "".concat(baseClass, "-has-action"), className, "".concat(baseClass, "-").concat(ratioClass));
    if (secondaryButton) {
        return (React.createElement("div", __assign({ className: cssClassNames }, attributes),
            React.createElement(UitkLayoutFlex, { alignItems: "center", className: getClassNameList('uitk-card-placeholder-has-action-inner'), justifyContent: "center" },
                React.createElement(UitkLayoutFlexItem, null, secondaryButton))));
    }
    return React.createElement("div", __assign({ className: cssClassNames }, attributes));
};
UitkCardPlaceholder.displayName = 'UitkCardPlaceholder';
UitkCardPlaceholder.defaultProps = {
    startPhase: UitkCardPlaceholderStartPhases.get('light')
};
// Temporary, unstable
var UitkCardAlohaPlaceholder = UitkCardPlaceholder;

export { UitkCardAlohaPlaceholder, UitkCardPlaceholder };
